"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const DialogWrapperRenderer_1 = __importDefault(require("../DialogWrapperRenderer"));
const validateSvg_1 = __importDefault(require("../../../shared/validateSvg"));
const style_1 = __importDefault(require("./style"));
const AlertRenderer = ({ alertContext }) => {
    const { Render } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const [hasSrcError, setHasSrcError] = (0, react_1.useState)(false);
    const [sourceType, setSourceType] = (0, react_1.useState)('image');
    (0, react_1.useEffect)(() => {
        const comprobate = async () => {
            if (alertContext === null || alertContext === void 0 ? void 0 : alertContext.imageSrc) {
                const isSvg = await (0, validateSvg_1.default)(alertContext.imageSrc);
                if (isSvg) {
                    setSourceType('svg');
                }
                setHasSrcError(false);
            }
        };
        if (hasSrcError)
            comprobate();
    }, [alertContext === null || alertContext === void 0 ? void 0 : alertContext.imageSrc, hasSrcError]);
    const onOk = (0, react_1.useCallback)(() => {
        if (alertContext === null || alertContext === void 0 ? void 0 : alertContext.onOk) {
            alertContext.onOk();
        }
    }, [alertContext]);
    return (react_1.default.createElement(DialogWrapperRenderer_1.default, { title: alertContext === null || alertContext === void 0 ? void 0 : alertContext.title, description: alertContext === null || alertContext === void 0 ? void 0 : alertContext.description, onOk: onOk },
        (alertContext === null || alertContext === void 0 ? void 0 : alertContext.imageSrc) && sourceType === 'image' && (react_1.default.createElement(Render.Image, { resizeMode: "cover", source: {
                uri: alertContext.imageSrc,
            }, style: style_1.default.image, onError: () => setHasSrcError(true) })),
        (alertContext === null || alertContext === void 0 ? void 0 : alertContext.imageSrc) && sourceType === 'svg' && (react_1.default.createElement(Render.View, { style: style_1.default.image },
            react_1.default.createElement(Render.SvgImage, { src: alertContext.imageSrc })))));
};
exports.default = AlertRenderer;
